import { useSelector } from 'react-redux';
import { AlgoliaConfigs } from '@alltrails/shared/types/algoliaConfigs';

export default function useAlgoliaConfigs(): AlgoliaConfigs {
  return useSelector((state: { algoliaConfigs: AlgoliaConfigs }) => state.algoliaConfigs);
}
